import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

export default function AdminPage() {
    const [auth, setAuth] = useState(null); // null = checking, false = logged out, object = admin

    useEffect(() => {
        // If no token in localStorage, skip the API call — go straight to login
        const token = localStorage.getItem("admin_token");
        if (!token) {
            setAuth(false);
            return;
        }
        api.get("/api/auth/me")
            .then((res) => setAuth(res.data))
            .catch(() => {
                localStorage.removeItem("admin_token");
                setAuth(false);
            });
    }, []);

    // Listen for session expiry from any API call
    useEffect(() => {
        const handleExpired = () => setAuth(false);
        window.addEventListener("auth:expired", handleExpired);
        return () => window.removeEventListener("auth:expired", handleExpired);
    }, []);

    if (auth === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-canvas" data-testid="admin-loading">
                <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-slate-200 border-t-brand-blue" />
            </div>
        );
    }

    if (auth === false) {
        return <AdminLogin onSuccess={setAuth} />;
    }

    return <AdminDashboard admin={auth} onLogout={() => setAuth(false)} />;
}
